import React, { Component } from 'react';

class Gallery extends Component {
    componentDidMount() {
        const publicUrl = process.env.PUBLIC_URL + '/';

        // Charger main.js uniquement pour ce composant
        this.script = document.createElement('script');
        this.script.src = `${publicUrl}assets/js/main.js`;
        this.script.async = true;
        document.body.appendChild(this.script);

        console.log('📸 main.js chargé pour Gallery');
    }

    componentWillUnmount() {
        // Supprimer le script quand le composant est démonté
        if (this.script) {
            document.body.removeChild(this.script);
            console.log('🧹 main.js retiré après avoir quitté Gallery');
        }
    }

    render() {
        const publicUrl = process.env.PUBLIC_URL + '/';

        const images = [
            {
                url: "https://img.freepik.com/free-photo/3d-rendering-beautiful-luxury-bedroom-suite-hotel-with-working-table_105762-2154.jpg",
                subtitle: "Diamantine",
                title: "Chambre à coucher",
            },
            {
                url: "https://img.freepik.com/free-photo/3d-rendering-modern-design-marble-tile-toilet-bathroom-wardrobe-with-walk-closet_105762-2073.jpg",
                subtitle: "Diamantine",
                title: "Salle de Bain",
            },
            {
                url: "https://img.freepik.com/free-photo/interior-moderno-de-la-cocina-en-colores-blancos_181624-58451.jpg",
                subtitle: "Diamantine",
                title: "Cuisine",
            },
            {
                url: "https://img.freepik.com/free-photo/interior-room-design-with-armchair-potted-plants_23-2149427990.jpg",
                subtitle: "Diamantine",
                title: "Séjour",
            },
            {
                url: "https://img.freepik.com/free-photo/portrait-young-woman-sitting-chair-balcony-holding-newspaper_23-2148161260.jpg",
                subtitle: "Diamantine",
                title: "Balcon",
            },
            {
                url: `${publicUrl}assets/img/others/21.jpg`,
                subtitle: "Diamantine",
                title: "Parking",
            }
        ];

        return (
            <div id='gallerie' className="ltn__img-slider-area">
                <div className="container-fluid">
                    <div className="row ltn__image-slider-4-active slick-arrow-1 slick-arrow-1-inner ltn__no-gutter-all">
                        {images.map((img, i) => (
                            <div className="col-lg-12" key={i}>
                                <div className="ltn__img-slide-item-4">
                                    <a href={img.url} data-rel="lightcase:myCollection">
                                        <img
                                            src={img.url}
                                            alt={img.title}
                                            style={{
                                                width: '100%',
                                                height: '400px',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    </a>
                                    <div className="ltn__img-slide-info">
                                        <div className="ltn__img-slide-info-brief gp-top">
                                            <h6>{img.subtitle}</h6>
                                            <h1 style={{ fontSize: '2rem', fontWeight: 700 }}>{img.title}</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default Gallery;
